import React from 'react';
import Select from '../../common/Select.jsx';

export default function ImportConfigSelection({allConfigs, selectedColConfig, setSelectedColConfig}) {

    if (allConfigs.length === 0) return <span className='description'>{I18n.t('no_column_config_description')}</span>

    return (
        <div className='form-group'>
            <label>{I18n.t('choose_column_config')}</label>
            <Select
            options={(allConfigs || []).map((c) => ({value: c.id, label: c.name}))}
            value={selectedColConfig}
            onChange={(val) => setSelectedColConfig(val)}
            />
            <span className='description'>{I18n.t('choose_column_config_description')}</span>
        </div>
    )
}